import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { LogoInfo } from '../models/logo-info';

@Injectable({ providedIn: 'root' })
export class LogosService {
  public baseUrl: string = window.location.origin;

  constructor(private http: HttpClient) {
    this.baseUrl = `${window.location.origin}/api/images/logos`;
  }

  getLogos(): Observable<LogoInfo[]> {
    return this.http.get<LogoInfo[]>(this.baseUrl);
  }

  addLogo(name: string, file: File): Observable<void> {
    const formData = new FormData();
    formData.append('name', name);
    formData.append('file', file);
    return this.http.post<void>(`${this.baseUrl}/add`, formData);
  }

  updateLogo(name: string, file: File): Observable<void> {
    const formData = new FormData();
    formData.append('name', name);
    formData.append('file', file);
    return this.http.post<void>(`${this.baseUrl}/update`, formData);
  }

  removeLogo(name: string): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${name}`);
  }
}
